import { FilterValue } from "../models/API";
import { BASE } from "../helpers/constants";
import { exportFilterStateToSQ } from "../helpers/dynamicFilterSQ";
import { FiltersStateType } from "../models/filters";
import { Tooltip } from "./Tooltip";
import { toggleVisibility } from "../helpers/shared";

interface CheckboxFilterProps {
  name: string;
  id: string;
  values: FilterValue[];
  dataState: FiltersStateType;
  setDataState: React.Dispatch<React.SetStateAction<FiltersStateType>>;
  isForProducts?: boolean;
  productType?: "Market" | "ProductGroup";
  tooltip: string;
}

export const CheckboxFilter = (props: CheckboxFilterProps) => {
  let currVisibleValues = [];
  const currentElementIndex = props.dataState.Dynamic.findIndex(
    (x) => x.Key === props.id
  );
  if (currentElementIndex >= 0) {
    currVisibleValues = props.dataState.Dynamic[currentElementIndex].Checked;
  }
  const values = props.values.map((val) => {
    const classForEl =
      currVisibleValues.includes(val.Id) ||
      props.dataState.Market.includes(val.Id) ||
      props.dataState.ProductGroup.includes(val.Id)
        ? BASE.activeClass
        : "";
    return (
      <li
        key={val.Id}
        className={classForEl}
        onClick={(ev) => selectCheckboxes(ev, val.Id)}
      >
        {val.Text}
      </li>
    );
  });
  const selectCheckboxes = (ev, id) => {
    const actualDataObj = { ...props.dataState };
    if (!props.isForProducts) {
      const actualArrElIndex = actualDataObj.Dynamic.findIndex(
        (x) => x.Key === props.id
      );
      const actualDataInArrIndex = actualDataObj.Dynamic[
        actualArrElIndex
      ].Checked.findIndex((y) => y === id);
      if (actualDataInArrIndex >= 0) {
        actualDataObj.Dynamic[actualArrElIndex].Checked.splice(
          actualDataInArrIndex,
          1
        );
      } else {
        actualDataObj.Dynamic[actualArrElIndex].Checked.push(id);
      }
    } else {
      const actualDataInArrIndex = actualDataObj[props.productType].findIndex(
        (x) => x === id
      );
      if (actualDataInArrIndex >= 0) {
        actualDataObj[props.productType].splice(actualDataInArrIndex, 1);
      } else {
        actualDataObj[props.productType].push(id);
      }
    }

    ev.target.classList.toggle(BASE.activeClass);
    exportFilterStateToSQ(actualDataObj);
    props.setDataState(actualDataObj);
  };

  const containerClass = props.productType ? "products-group" : "filter-group";

  const toggle = (ev) => {
    toggleVisibility(ev, `.${containerClass}`);
  };

  return (
    <div className={containerClass}>
      <div className="header">
        <h3 onClick={toggle}>
          {props.name}

          {props.tooltip && !props.isForProducts && (
            <Tooltip htmlString={props.tooltip} />
          )}
        </h3>

        {props.tooltip && props.isForProducts && (
          <Tooltip htmlString={props.tooltip} />
        )}
      </div>
      <ul>{values}</ul>
    </div>
  );
};
